import { DEV_SITE_HOSTS } from '@seek/adv-constants';
import {
  type Brand,
  type Country,
  getLocalizedRoutes,
  siteConfig,
  siteNames,
} from '@seek/melways-sites';

import * as pageRoutes from './constants/routes';
import type { EmployerSiteName, Environment } from './types';

export const publicPath = '/static/hirer-invoices-ui-unified';

// Note: The first environment will be used for local development.
export const environments: Record<string, Environment> = {
  development: 'dev',
  production: 'production',
  staging: 'staging',
};

export const routes: Array<{ route: string; name: string }> = [
  {
    route: pageRoutes.ROUTE_PAY_LEGACY,
    name: 'legacy-pay',
  },
  {
    route: pageRoutes.ROUTE_ROOT,
    name: 'invoicing',
  },
  {
    route: pageRoutes.ROUTE_PAYABLE,
    name: 'payable',
  },
  {
    route: pageRoutes.ROUTE_HISTORY,
    name: 'history',
  },
  {
    route: pageRoutes.ROUTE_PAY,
    name: 'pay',
  },
  {
    route: pageRoutes.ROUTE_VIRTUAL_ACCOUNTS,
    name: 'virtual-accounts',
  },
];

const localiseRoutesForSite = getLocalizedRoutes(routes);

const createSites = (sites: EmployerSiteName[]) =>
  sites.map((site) => ({
    name: site,
    host: DEV_SITE_HOSTS[site],
    routes: localiseRoutesForSite(site),
  }));

export const sites = createSites([
  siteNames.employer.seek.au,
  siteNames.employer.seek.nz,
  siteNames.employer.seek.hk,
  siteNames.employer.seek.th,
  siteNames.employer.seek.sg,
  siteNames.employer.seek.id,
  siteNames.employer.seek.ph,
  siteNames.employer.seek.my,
]);

export const getCountryFromSite = (site: EmployerSiteName): Country =>
  siteConfig[site].classification.country;

export const getBrandFromSite = (site: EmployerSiteName): Brand =>
  siteConfig[site].classification.brand;
